import { CustomerRequestKey } from './customer.request-keys';

export class ClearCustomerUIAction {
  static readonly type = '[Customer UI] Clear';
}

export class SetCustomerUILoadingAction {
  static readonly type = '[Customer UI] Set Loading';
  constructor(public key: CustomerRequestKey) {}
}

export class SetCustomerUILoadedAction {
  static readonly type = '[Customer UI] Set Loaded';
  constructor(public key: CustomerRequestKey) {}
}

export class SetCustomerUIErrorAction {
  static readonly type = '[Customer UI] Set Error';
  constructor(public key: CustomerRequestKey) {}
}
